import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/components/Layouts/Layouts';
import { TS_Input } from '@nu-art/thunderstorm-frontend/components/TS_Input/TS_Input';
import { cloneObj } from '@nu-art/ts-common';
import { SimpleListAdapter } from '@nu-art/thunderstorm-frontend/components/adapter/Adapter';
import { QRangeInput } from '@app/hcs-frontend';
import { ComponentSync, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, } from '@nu-art/thunderstorm-frontend/index';
export class Component_IncidenceEditor extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        const propIncidence = nextProps.incidence ? cloneObj(nextProps.incidence) : undefined;
        state.incidence = state.incidence || {};
        state.incidence.numerator = state.incidence.numerator || propIncidence?.numerator;
        state.incidence.denominator = state.incidence.denominator || propIncidence?.denominator || 100000; // denominator default value is 100,000.
        return state;
    }
    updateProfileIncidence = (incidence) => {
        const newIncidence = { numerator: incidence.numerator, denominator: incidence.denominator };
        if (incidence.numerator)
            newIncidence.denominator = Math.max(incidence.numerator[1], incidence.denominator);
        this.setState({ incidence: newIncidence }, () => {
            if (!incidence || !incidence.denominator)
                return;
            if (Number.isNaN(incidence.denominator))
                return;
            this.props.onChanged({
                numerator: incidence.numerator,
                denominator: incidence.numerator?.[1] !== undefined ? Math.max(incidence.numerator[1], incidence.denominator) : incidence.denominator
            });
        });
    };
    deleteIncidence = () => {
        this.props.onChanged(undefined);
        this.setState({ incidence: { numerator: undefined, denominator: 100000 } });
    };
    renderNumerator = () => {
        if (this.props.disableEdit)
            return this.state.incidence.numerator
                ? (this.state.incidence.numerator[0] === this.state.incidence.numerator[1]
                    ? _jsx("div", { children: this.state.incidence.numerator[0] })
                    : _jsxs("div", { children: [this.state.incidence.numerator[0], " - ", this.state.incidence.numerator[1]] }))
                : '';
        return _jsx(QRangeInput, { placeholder: 'Numerator Range', value: this.state.incidence.numerator, onValueBlur: val => this.updateProfileIncidence({ numerator: val, denominator: this.state.incidence.denominator }) });
    };
    renderDenominator = () => {
        if (this.props.disableEdit)
            return this.state.incidence.denominator ? _jsx("div", { children: this.state.incidence.denominator }) : '';
        return _jsx(TS_Input, { type: 'number', placeholder: 'Denominator', value: this.state.incidence.denominator ? `${this.state.incidence.denominator}` : undefined, onBlur: value => {
                if (Number.isNaN(value))
                    return;
                let numberToInput = Number.parseInt(value);
                if (this.state.incidence.numerator)
                    numberToInput = Math.max(this.state.incidence.numerator[1], numberToInput);
                this.updateProfileIncidence({ numerator: this.state.incidence.numerator, denominator: numberToInput });
            } });
    };
    render() {
        return _jsx(LL_V_L, { className: 'match_width', onContextMenu: (e) => {
                if (this.props.disableEdit)
                    return;
                const menuItems = [
                    { label: 'Remove', onClick: () => this.deleteIncidence() },
                ];
                const rightClickMenu = {
                    id: 'prognosis-right-click-menu',
                    adapter: SimpleListAdapter(menuItems, renderer => _jsx("div", { className: 'node-data', children: renderer.item.label })),
                    originPos: { y: e.clientY, x: e.clientX, },
                    modalPos: { x: 0, y: 1 },
                    onNodeClicked: (path, item) => {
                        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        item.onClick?.();
                    }
                };
                ModuleFE_MouseInteractivity.showMenu(rightClickMenu);
            }, children: _jsxs(LL_H_C, { children: [this.renderNumerator(), _jsx("span", { className: 'dialog__field-title', style: { paddingInline: '8px' }, children: "out of" }), this.renderDenominator()] }) });
    }
}
//# sourceMappingURL=Component_IncidenceEditor.js.map